<template>
  <div>
    <el-input @blur="blur($event)" v-model="input" placeholder="请输入内容"></el-input>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="ID" label="日期" width="180">
      </el-table-column>
      <el-table-column label="姓名">
        <template slot-scope="{row,$index}">
          <el-input v-model="row.name" placeholder="请输入内容">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="地址">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '', // 输入框
      tableData: [], // 表格
      inputdata: [], // 输入框内容转数组
    }
  },
  mounted() {
  },
  methods: {
    // onChange(value) {
    //   console.log(5555, value)
    //   // this.tableData = []
    //   console.log(1111, this.input)
    //   this.inputdata = value.split(',') // 获取输入框内容，英文逗号隔开
    //   console.log(2222, this.inputdata)
    //   this.inputdata.forEach(element => {
    //     console.log(111122, element)
    //     this.tableData.push({
    //       ID: element,
    //       name: '',
    //       address: '上海市普陀区金沙江路 1518 弄'
    //     })
    //   })

    // },
    blur(event) {
      // this.tableData = []
      let value = event.target.value // 获取输入的值
      if (!value) {
        this.tableData = []
        return
      }
      let ids = value.split(',').filter((item) => item)
      console.log(1111, this.input)
      this.tableData = ids.map((item) => {
        const index = this.tableData.findIndex((ele) => ele.ID == item)
        // console.log('tableData',this.tableData);
        // debugger
        if (index != -1) {
          const listItem = this.tableData[index]
          this.tableData.splice(index, 1)
          return listItem
        } else {
          return {
            ID: item,
            name: '王小虎',
            address: '上海市普陀区金沙江路 1518 弄',
          }
        }
      })
    },
    handleDelete(index, row) {
      this.tableData.splice(index, 1)  // 表格删除，通过下标删除，这样就可以解决重复的问题了
      this.inputdata.splice(index, 1)  // 输入框删除
      console.log(111, this.tableData)
      this.input = this.inputdata.toString() // 转成string展示
      console.log(111, this.input)
      // this.tableData = this.tableData.splice(index, 1)
    }
  }
}

</script>